import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDSnackbar from "components/MDSnackbar";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { deletePositionDO, getPositionsDO, updatePositionDO } from "utils/positionsUtils";
import { uploadImageDO } from "utils/positionsUtils";
import { postLogDO } from "utils/logsUtils";
import { setCurrentDialog, useMaterialUIController } from "context";
import { styled } from "@mui/material/styles";
import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { Permission, PermissionType } from "models/BO/BoRole";
import { PageNumber } from "../../accessNumbers";
import { Position } from "models/content/Position";
import { GridActionsCell, GridActionsCellItem } from "@mui/x-data-grid-pro";
import { Delete, Edit } from "@mui/icons-material";
import AddEditPositionDialog from "./addNewPositionDialog";
import { DialogType } from "components/alove/AloveDialog";
import { DeleteItem } from "layouts/itemPageContainer/components/deleteItem";
import { ImageUploader } from "components/alove/ImageUploader";

const MDButton = require("components/MDButton").default;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

let positions = [];
function Positions() {
  const pageNumber = PageNumber.Positions;
  const [controller, dispatch] = useMaterialUIController();
  const { currentUser, currentBrand, currentRole } = controller;
  const [refresh, setRefresh] = useState(false);
  const [where, setPlace] = useState("Content");
  const [currentPosition, setCurrentPosition] = useState(null as Position | null);

  const columns: TableColumnProps<Position>[] = [
    {
      field: "positionName",
      headerName: "Position",
      flex: 1,
    },
    {
      field: "preview",
      headerName: "Preview",
      width: 200,
      renderCell: (params) => previewImage(params.row),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      align: "center",
      renderCell: (params) => rowActionsElement(params.row),
    },
  ];

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result as string;
        resolve(baseURL);
      };
    });
  };


  const getPositions = async (filter, page) => {
    positions = await getPositionsDO(where?.toLowerCase());
    return positions;
  };

  // const CustomWidthTooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     maxWidth: 500,
  //   },
  // });

  const rowActionsElement = (p) => (
    <Grid  >
      {currentRole.hasAccess(pageNumber, PermissionType.Edit) && (
        <GridActionsCellItem
          icon={<Edit />}
          label="Edit"
          onClick={() => {
            setCurrentPosition(p);
            setCurrentDialog(dispatch, DialogType.AddNewPosition)
          }}
        />
      )}
      {currentRole.hasAccess(pageNumber, PermissionType.Delete) && (
        <GridActionsCellItem
          icon={<Delete />}
          label="Delete"
          onClick={() => {
            setCurrentPosition(p);
            setCurrentDialog(dispatch, DialogType.DeleteWarning)
          }}
        />
      )}
 
      <ImageUploader
        onUploaded={(images) => updatePositionDO(p.id, { img: images[0] }).then(() => setRefresh(!refresh))}
        iconOnly
        folder="positions"
        fileType="image/*"
      />
      </Grid>
  );

  const previewImage = (p) => {
    return (
      <Tooltip

        title={<img src={p.img} height={250} width="auto" />}
      >
        <img src={p.img} height={50} />
      </Tooltip>
    );
  };

  const getTreeDataPath = (data) => {
    let path: string[] = [];
    let current = data;
    while (current) {
      path.push(current.positionName);
      current = positions.find((p: Position) => p.id == current.parentId);
    }
    return path.reverse();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TablePage
        title="Positions"
        table={{
          columns,
          loadNext: getPositions,
          getTreeDataPath,
        }}
        refresh={refresh}
        actions={{
          title: "Positions Actions",
          page: pageNumber,
          addActions: [
            {
              label: "Position",
              role: PermissionType.AddNew,
              variant: "contained",
              onClick: () =>{
                setCurrentPosition(null)
                 setCurrentDialog(dispatch, DialogType.AddNewPosition)
                }
            },
          ],
        }}
      />
    <AddEditPositionDialog refresh={() => setRefresh(!refresh)} position={currentPosition} />
      <DeleteItem
        onDelete={async () => {
          await deletePositionDO(currentPosition?.id)
          setRefresh(!refresh)
        }}
        contetnText="Are you sure you want to delete this position?"
        buttonText="Delete"
      />
    </DashboardLayout>
    
  );
}

export default Positions;
